import { SVGProps, SVGAttributes } from 'react';

const UserActivityIcon = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
    const { stroke } = props;
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_5_152" maskUnits="userSpaceOnUse" x="0" y="0" width="48" height="49">
                <rect y="0.5" width="48" height="48" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_5_152)">
                <path d="M8 40.5V16.5H16V40.5H8ZM18 40.5V26.5H26V40.5H18ZM32 40.5V8.5H40V40.5H32Z"
                      fill={stroke || "#206FA5"}
                />
            </g>
        </svg>
    );
};

export default UserActivityIcon;
